export const texts = {
  welcome: {
    de: 'Dashboard',
    en: 'Dashboard'
  },
  newJob: {
    de: 'Neue Stelle',
    en: 'New position'
  },
  reporting: {
    title: {
      de: 'Auswertung',
      en: 'Analytics'
    },
    detailLink: {
      de: 'Zur detaillierten Auswertung',
      en: 'View detailed analytics'
    }
  },
  preparedJobs: {
    title: {
      de: 'Analysierte Stellen',
      en: 'Analyzed positions'
    },
    empty: {
      de: 'Du hast derzeit keine Stellen zur Freigabe',
      en: 'You currently have no positions to approve'
    }
  },
  runningJobs: {
    title: {
      de: 'Laufende Stellen',
      en: 'Active positions'
    },
    empty: {
      de: 'Du hast derzeit keine laufenden Stellen',
      en: 'You currently have no active positions'
    }
  },
  pool: {
    title: {
      de: 'Pool',
      en: 'Pool'
    },
    size: {
      de: 'Talente im Pool',
      en: 'Talents in pool'
    },
    growth: {
      de: 'Entwicklung Poolgröße',
      en: 'Pool size over time'
    },
    switchSignals: {
      de: 'Wechselsignale (30 Tage)',
      en: 'Switch signals (30 days)'
    },
    engagements: {
      de: 'Engagements (30 Tage)',
      en: 'Engagements (30 days)'
    },
    detailLink: {
      de: 'Zum Pool',
      en: 'View pool'
    }
  },
  viewAll: {
    de: 'Alle ansehen',
    en: 'View all'
  },
  more: {
    de: 'weitere',
    en: 'more'
  }
};
